// extracted by mini-css-extract-plugin
export default {"header":"Contact_header__X8mwu","main":"Contact_main__7rEWg","button":"Contact_button__yHrMS","contactButton":"Contact_contactButton__Sj6-f"};